import organizations from "@/apis/coreIAM/organizations"
import { organizationsTypes } from "@/store/mutationTypes"

export default {
    state: {
        locations: [],
        fetchAllLocations: {
            pending: false,
            error: null,
        },
        addLocation: {
            pending: false,
            error: null,
        },
        removeLocation: {
            pending: false,
            error: null,
        },
        fetchOrganizationLocationUsers: {
            pending: false,
            error: null,
        },
        addOrganizationLocationUser: {
            pending: false,
            error: null,
        },
        removeOrganizationLocationUser: {
            pending: false,
            error: null,
        }
    },
    mutations: {
        [organizationsTypes.FETCH_ALL_LOCATIONS_REQUEST]: function (state) {
            state.fetchAllLocations.pending = true;
        },
        [organizationsTypes.FETCH_ALL_LOCATIONS_SUCCESS]: function (state, locations) {
            state.locations = locations;
            state.fetchAllLocations.error = null;
            state.fetchAllLocations.pending = false
        },
        [organizationsTypes.FETCH_ALL_LOCATIONS_FAILURE]: function (state, error) {
            state.fetchAllLocations.error = error;
            state.fetchAllLocations.pending = false;
        },
        [organizationsTypes.ADD_LOCATION_REQUEST]: function (state) {
            state.addLocation.pending = true;
        },
        [organizationsTypes.ADD_LOCATION_SUCCESS]: function (state) {
            state.addLocation.error = null;
            state.addLocation.pending = false;
        },
        [organizationsTypes.ADD_LOCATION_FAILURE]: function (state, error) {
            state.addLocation.error = error;
            state.addLocation.pending = false;
        },
        [organizationsTypes.REMOVE_LOCATION_REQUEST]: function (state) {
            state.removeLocation.pending = true;
        },
        [organizationsTypes.REMOVE_LOCATION_SUCCESS]: function (state) {
            state.removeLocation.error = null;
            state.removeLocation.pending = false;
        },
        [organizationsTypes.REMOVE_LOCATION_FAILURE]: function (state, error) {
            state.removeLocation.error = error;
            state.removeLocation.pending = false;
        },
        [organizationsTypes.FETCH_LOCATION_USERS_REQUEST]: function (state) {
            state.fetchOrganizationLocationUsers.pending = true;
        },
        [organizationsTypes.FETCH_LOCATION_USERS_SUCCESS]: function (state) {
            state.fetchOrganizationLocationUsers.error = null;
            state.fetchOrganizationLocationUsers.pending = false;
        },
        [organizationsTypes.FETCH_LOCATION_USERS_FAILURE]: function (state, error) {
            state.fetchOrganizationLocationUsers.error = error;
            state.fetchOrganizationLocationUsers.pending = false;
        },
        [organizationsTypes.ADD_LOCATION_USER_REQUEST]: function (state) {
            state.addOrganizationLocationUser.pending = true;
        },
        [organizationsTypes.ADD_LOCATION_USER_SUCCESS]: function (state) {
            state.addOrganizationLocationUser.error = null;
            state.addOrganizationLocationUser.pending = false;
        },
        [organizationsTypes.ADD_LOCATION_USER_FAILURE]: function (state, error) {
            state.addOrganizationLocationUser.error = error;
            state.addOrganizationLocationUser.pending = false;
        },
        [organizationsTypes.REMOVE_LOCATION_USER_REQUEST]: function (state) {
            state.removeOrganizationLocationUser.pending = true;
        },
        [organizationsTypes.REMOVE_LOCATION_USER_SUCCESS]: function (state) {
            state.removeOrganizationLocationUser.error = null;
            state.removeOrganizationLocationUser.pending = false;
        },
        [organizationsTypes.REMOVE_LOCATION_USER_FAILURE]: function (state, error) {
            state.removeOrganizationLocationUser.error = error;
            state.removeOrganizationLocationUser.pending = false;
        },

    },
    actions: {
        async fetchAllLocations({ commit }, payload) {
            commit(organizationsTypes.FETCH_ALL_LOCATIONS_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .getOrganizationLocations(payload.organizationUuid)
                    .then((locations) => {
                        commit(organizationsTypes.FETCH_ALL_LOCATIONS_SUCCESS, locations.data)
                        resolve(locations.data)
                    }).catch((error) => {
                        commit(organizationsTypes.FETCH_ALL_LOCATIONS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addLocation({ commit }, payload) {
            commit(organizationsTypes.ADD_LOCATION_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .addOrganizationLocation(payload.organizationUuid, payload.locationUuid)
                    .then((location) => {
                        commit(organizationsTypes.ADD_LOCATION_SUCCESS)
                        resolve(location.data)
                    })
                    .catch((error) => {
                        commit(organizationsTypes.ADD_LOCATION_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async removeLocation({ commit }, payload) {
            commit(organizationsTypes.REMOVE_LOCATION_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .removeOrganizationLocation(payload.organizationUuid, payload.locationUuid)
                    .then(() => {
                        commit(organizationsTypes.REMOVE_LOCATION_SUCCESS)
                        resolve()
                    })
                    .catch(error => {
                        commit(organizationsTypes.REMOVE_LOCATION_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchOrganizationLocationUsers({ commit }, payload) {
            commit(organizationsTypes.FETCH_LOCATION_USERS_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .listOrganizationLocationUsers(payload.organizationUuid, payload.locationUuid)
                    .then((users) => {
                        commit(organizationsTypes.FETCH_LOCATION_USERS_SUCCESS)
                        resolve(users.data)
                    })
                    .catch(error => {
                        commit(organizationsTypes.FETCH_LOCATION_USERS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addOrganizationLocationUser({ commit }, payload) {
            commit(organizationsTypes.ADD_LOCATION_USER_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .addOrganizationLocationUser(payload.organizationUuid, payload.locationUuid, payload.userUuid, payload.role)
                    .then(() => {
                        commit(organizationsTypes.ADD_LOCATION_USER_SUCCESS)
                        resolve()
                    })
                    .catch(error => {
                        commit(organizationsTypes.ADD_LOCATION_USER_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async removeOrganizationLocationUser({ commit }, payload) {
            commit(organizationsTypes.REMOVE_LOCATION_USER_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .removeOrganizationLocationUser(payload.organizationUuid, payload.locationUuid, payload.userUuid, payload.role)
                    .then(() => {
                        commit(organizationsTypes.REMOVE_LOCATION_USER_SUCCESS)
                        resolve()
                    })
                    .catch(error => {
                        commit(organizationsTypes.REMOVE_LOCATION_USER_FAILURE, error)
                        reject(error)
                    })
            })
        },
    }
}